const countryMap = {
    'MX': 'Mexico',
    'CL': 'Chile',
    'PE': 'Peru',
    'AU': 'Australia',
    'ID': 'Indonesia',
    'JP': 'Japan',
    'IN': 'India',
    'MY': 'Malaysia',
    'TH': 'Thailand',
    'SG': 'Singapore',
    'VN': 'Vietnam',
    'CN': 'China',
    'BR': 'Brazil',
    'GR': 'Greece',
    'MA': 'Morocco',
    'CZ': 'Czech Republic',
    'NL': 'Netherlands',
    'TR': 'Turkey',
    'BE': 'Belgium',
    'LT': 'Lithuania',
    'ZA': 'South Africa',
    'GH': 'Ghana',
    'RU': 'Russian Federation',
    'FR': 'France',
    'PT': 'Portugal',
    'GB': 'United Kingdom',
    'UA': 'Ukraine',
    'UZ': 'Uzbekistan',
    'MN': 'Mongolia',
    'BG': 'Bulgaria',
    'ES': 'Spain',
    'AT': 'Austria',
    'KZ': 'Kazakhstan',
    'RS': 'Serbia',
    'DE': 'Germany',
    'RO': 'Romania',
    'DK': 'Denmark',
    'NO': 'Norway',
    'AE': 'United Arab Emirates',
    'CH': 'Switzerland',
    'PL': 'Poland',
    'ZM': 'Zambia',
    'ZW': 'Zimbabwe',
    'CA': 'Canada',
    'US': 'United States',
    'AR': 'Argentina',
    'CO': 'Colombia',
    'EC': 'Ecuador',
    'UY': 'Uruguay',
    'PY': 'Paraguay',
    'BO': 'Bolivia',
    'VE': 'Venezuela',
    'HT': 'Haiti',
    'DO': 'Dominican Republic',
    'CU': 'Cuba',
    'JM': 'Jamaica',
    'TT': 'Trinidad and Tobago',
    'BS': 'Bahamas',
    'BB': 'Barbados',
    'BL': 'Saint Barthélemy',
    'GP': 'Guadeloupe',
    'MQ': 'Martinique',
    'RE': 'Réunion',
    'GF': 'French Guiana',
    'PF': 'French Polynesia',
    'NC': 'New Caledonia',
    'WF': 'Wallis and Futuna',
    'YT': 'Mayotte',
    'GL': 'Greenland',
    'FO': 'Faroe Islands',
    'IS': 'Iceland',
    'SE': 'Sweden',
    'FI': 'Finland',
    'EE': 'Estonia',
    'LV': 'Latvia',
    'BY': 'Belarus',
    'MD': 'Moldova',
    'AM': 'Armenia',
    'GE': 'Georgia',
    'AZ': 'Azerbaijan',
    'KW': 'Kuwait',
    'SA': 'Saudi Arabia',
    'QA': 'Qatar',
    'BH': 'Bahrain',
    'OM': 'Oman',
    'YE': 'Yemen',
    'JO': 'Jordan',
    'LB': 'Lebanon',
    'SY': 'Syria',
    'IQ': 'Iraq',
    'EG': 'Egypt',
    'PS': 'Palestine',
    'IL': 'Israel',
    'CY': 'Cyprus',
    'MK': 'North Macedonia',
    'AL': 'Albania',
    'KG': 'Kyrgyzstan',
    'TJ': 'Tajikistan',
    'TM': 'Turkmenistan',
    'PK': 'Pakistan',
    'AF': 'Afghanistan',
    'BD': 'Bangladesh',
    'LK': 'Sri Lanka',
    'MM': 'Myanmar',
    'NP': 'Nepal',
    'BT': 'Bhutan',
    'LA': 'Laos',
    'KH': 'Cambodia',
    'PH': 'Philippines',
    'TL': 'Timor-Leste',
    'KR': 'South Korea',
    'MO': 'Macau',
    'HK': 'Hong Kong',
    'TW': 'Taiwan',
};

function getCountryName(input) {
    if (input == "all") {
        console.log("come inside");
        return "All Countries"
    }
    input = input.trim();

    if (input.length === 2 && input === input.toUpperCase()) {
        const country = countryMap[input.toUpperCase()];
        if (country) {
            return country;
        }
    } else {
        return input.charAt(0).toUpperCase() + input.slice(1).toLowerCase(); 
    }
}

export default getCountryName;